export default __webpack_public_path__ + "static/the-differance-is-clear-landscape-en-e8ee2f876169ab8995a128c7cc5d9b0b.mp4";